import Vue from "vue";
export function httpStatus(response) {
  if (response.status >= 200 && response.status < 400) {
    let text = "";
    switch (response.config.method) {
      case "put":
        text = "Dina ändringar är sparade";
        break;
      case "post":
        text = "Ny data tillaggd";
        break;
      case "delete":
        text = "Data borttagen";
        break;
    }

    Vue.notify({
      type: "success",
      text: text
    });
    return response;
  }
  throw response;
}

export function parseError(error) {
  if (!(error instanceof TypeError)) {
    Vue.tostar.e(error.statusText);
    Vue.notify({
      type: "error",
      text: error.statusText
    });
    return new Promise((resolve, reject) => reject(error.json()));
  }
}
